import { render, staticRenderFns } from "./TabRecentSlideCopy.vue?vue&type=template&id=b19f8d6c&scoped=true"
import script from "./TabRecentSlideCopy.vue?vue&type=script&lang=js"
export * from "./TabRecentSlideCopy.vue?vue&type=script&lang=js"
import style0 from "./TabRecentSlideCopy.vue?vue&type=style&index=0&id=b19f8d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19f8d6c",
  null
  
)

export default component.exports